import { NO_RESULTS_MESSAGE } from "src/containers/teamMembers/constants";
import { Content, Title } from "src/containers/workers/ListWorkers/EmptyPanel/EmptyPanel.styles";

export function EmptyPanel({ filter }: { filter: string }) {
  return (
    <Content>
      {filter.length ? <Title>{NO_RESULTS_MESSAGE}</Title> : <Title>No Team members found.</Title>}
    </Content>
  );
}
